import React from 'react';
import BadgeComponent from '../Badge.component';
import { getDateTime } from '../../services/date.service';
import { TIME_FORMAT } from '../../constants/date.contant';
import CellComponent from '../Cell.component';
import { Notification } from '../../redux/Notification/NotificationType';
import { NOTIFICATION_ICON_COLOR } from '../../constants/notification.constant';
import styled from 'styled-components';
import EventIconComponent from './EventIcon.component';
import TooltipComponent from '../Tooltip.component';
import { useTranslation } from 'react-i18next';
import { useModalManager } from '../../hooks/ModalManager.hook';
import EventDetailsModalComponent from '../Modal/Event/EventDetailsModal.component';

interface EventProps extends React.AllHTMLAttributes<HTMLElement> {
  event: Notification;
  showType?: boolean;
  showDeleteIcon?: boolean;
  onUpdate: Function;
  onRead: (event: Notification) => void;
}

const StyledEventCandidateName = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 5px 0 5px;
  text-decoration: none;
  white-space: nowrap;

  &:hover .tooltip {
    visibility: visible;
    transition-delay: 0.5s;
  }
`;
const StyledEventContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
`;
const StyledEventTime = styled.div`
  min-width: fit-content;
`;
const StyledEventInfo = styled.div`
  display: flex;
  width: 80%;
`;

const EventComponent = ({ event, showType, onUpdate, onRead }: EventProps) => {
  const { t } = useTranslation();
  const { openModal } = useModalManager();
  const eventTitle = event.notification?.title;
  const eventType = t(`notifications.types.${event.type}`);
  const eventContent = showType ? eventTitle + ' - ' + eventType : eventTitle;

  const handleClickEvent = (ev: any): void => {
    ev.preventDefault();
    ev.stopPropagation();
    openModal(EventDetailsModalComponent, {
      event,
      callbackFn: onUpdate,
    });
    onRead?.(event);
  };

  return (
    <CellComponent stretched className="event-wrapper">
      <BadgeComponent
        appearance="primary"
        text=""
        justifyContent="left"
        className="event-badge"
        color={NOTIFICATION_ICON_COLOR[event.type]}
      >
        <StyledEventContent onClick={ev => handleClickEvent(ev)}>
          <StyledEventInfo>
            <EventIconComponent
              eventType={event.type}
              size={16}
              withoutBg={true}
            />
            <StyledEventCandidateName>
              {eventContent}
              {!showType ? (
                <TooltipComponent
                  tooltip={eventTitle!}
                  caption={'Тип: ' + eventType}
                />
              ) : (
                ''
              )}
            </StyledEventCandidateName>
          </StyledEventInfo>
          <StyledEventTime>
            {getDateTime(event.sendAt, TIME_FORMAT)}
          </StyledEventTime>
        </StyledEventContent>
      </BadgeComponent>
    </CellComponent>
  );
};

export default EventComponent;
